module.exports = __webpack_public_path__ + "static/media/icon-lp-twenty-four-seven.ff04db7e.svg";